import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#icon-button" }),
  /*#__PURE__*/_createTextVNode(" Icon Button ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Use icons to add more meaning to Button. You can use icon alone to save some space, or use it with text. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Upload")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload el-icon-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-edit"
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-share"
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-delete"
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-search"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, { type: "primary" }, {
        default: _withCtx(() => [
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}